/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setAds } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import MobilePlacement from 'pages/dashboard/embeds/management/ads/placement/mobile/mobile_placement';



/* ========== ~~~~~~~~~~ EMBED ADs RAIL PLACEMENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    embedStatus: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData
});

// map actions
const mapDispatchToProps = dispatch => ({
    setAds: (ad1, ad2, overlay, mobile) => dispatch(setAds(ad1, ad2, overlay, mobile)),
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MobilePlacement);
